import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { Agent } from '../../interfaces/Agent';
import { ResponseObject } from '../../interfaces/App';
import { getCompanyAgents } from '../../services/agentService';
import { useAccessibleAgentsFilter } from '../useAccessibleAgentsFilter';

export const useCompanyAgents = (enabled = true) => {
  const { data, isLoading, error, isFetching } = useQuery<
    ResponseObject,
    Error
  >({
    queryKey: ['agents', 'company'],
    queryFn: getCompanyAgents,
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    // Don't set refetchOnMount to false - let React Query refetch stale data
    // This allows cache invalidation to work properly
    refetchOnMount: 'always', // Always refetch on mount to pick up invalidated data
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });

  const agents = useMemo(() => {
    return (data?.message as Agent[]) || [];
  }, [data]);

  const { data: accessibleAgents, isAccessLoading } =
    useAccessibleAgentsFilter(agents);

  return {
    data: accessibleAgents,
    isLoading: isLoading || isAccessLoading,
    error,
    isFetching,
  };
};
